/**
 * if need can cache ajax
 * is need?
 * expire time?
 */

class MyCache {
  constructor(expireTime) {
    this.expireTime = expireTime * 60 * 1000;
    this.cache = {};
  }
  today_time() {
    const formattedDate = new Date().toISOString().split('T')[0];
    return {
      st: `${formattedDate} 00:00:00`,
      et: `${formattedDate} 23:59:59`,
      sh: 0,
      eh: 24,
      id: 'allShopsOfUser',
      isOnBusinessTime: 1,
      gauss: 5,
      minTime: 5,
    };
  }
  set(key, value) {
    const now = Date.now();
    this.cache[key] = {
      value,
      expireAt: now + this.expireTime,
    };
  }

  get(key) {
    const now = Date.now();
    const cachedItem = this.cache[key];
    if (cachedItem && cachedItem.expireAt > now) {
      return cachedItem.value;
    } else {
      this.remove(key);
      return 'OVER';
    }
  }

  remove(key) {
    delete this.cache[key];
  }

  clear() {
    this.cache = {};
  }

  has(key) {
    const now = Date.now();
    const cachedItem = this.cache[key];
    return cachedItem && cachedItem.expireAt > now;
  }
}

export default new MyCache(5);
